import { createSelector } from '@reduxjs/toolkit';
import { OrganizationMemberRole } from 'domain/Organization';

import { organizationApi } from './organizationApi';

import type { RootState } from 'store';

export const selectCurrentOrganization = (state: RootState) =>
  organizationApi.endpoints.getManagedOrganizations.select()(state)?.data?.organizations?.[0];

export const selectCurrentOrganizationId = createSelector(
  selectCurrentOrganization,
  (data) => data?.organization?.organizationId
);

export const selectIsUserCurrentOrganizationAdmin = createSelector(
  selectCurrentOrganization,
  (data) => data?.organizationRole === OrganizationMemberRole.ADMIN
);
